import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from 'app/modules/sfdc/actions'
import * as selectors from 'app/modules/sfdc/selectors'


import SalesforceLeadRouting from '../SalesforceLeadRouting'

function mapStateToProps(state) {
  return {
    sfdcObjectList: selectors.isSFDCObjectListLoaded(state),
    sfdcObjectListErr: selectors.sfdcObjectListErrStatus(state),
    sfdcAccountFieldsList: selectors.isSFDCAccountFieldsListLoaded(state),
    sfdcContactFieldsList: selectors.isSFDCContactFieldsListLoaded(state),
    sfdcLeadFieldsList: selectors.isSFDCLeadFieldsListLoaded(state),
    sfdcFieldsListErr: selectors.sfdcFieldListErrStatus(state),
    sfdcLeadRoutingSettings: selectors.isSFDCLeadRoutingSettingsLoaded(state),
    sfdcLeadRoutingSettingsErr: selectors.sfdcLeadRoutingSettingsErrStatus(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesforceLeadRouting)


// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/SalesforceFilter/containers/SalesforceLeadRouting.js